<div class="sidenav-container">
    <mat-sidenav-container>
        <!-- Toggle button for left sidebar -->
        <mat-sidenav #sideNavLeft mode="side" [opened]="leftSidenavOpen"
                     [fixedInViewport]="true" class="left-sidenav">
            <div class="container-fluid px-0">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-6 section fields">
                            <div class="row g-0">
                                <div class="col"><h3 jhiTranslate="field-manager.map.fields">Fields</h3></div>
                                <div class="col d-flex align-items-center justify-content-end">
                                    <button class="btn btn-outline-secondary me-2" (click)="startCreateField()"
                                            [disabled]="disableCreateAction()"><i class="fa fa-plus"></i> {{ 'add' | translate }}
                                    </button>
                                </div>
                            </div>
                            <jhi-workbench-location-list [locationTypes]="[LocationTypeEnum.FIELD]"
                                                         (onSelect)="onFieldItemSelect($event);"
                                                         (onEditItem)="onFieldItemEdit($event)"
                                                         (onDeleteItem)="onFieldItemDelete($event)"
                                                         #fieldList></jhi-workbench-location-list>
                        </div>
                        <div class="col-6 section blocks" *ngIf="selectedField">
                            <div class="row g-0">
                                <div class="col"><h3 jhiTranslate="field-manager.map.blocks">Blocks</h3></div>
                                <div class="col d-flex align-items-center justify-content-end">
                                    <button class="btn btn-outline-secondary me-2"
                                            *ngIf="isSelected('FIELD') || isSelected('BLOCK')"
                                            (click)="startCreateBlock()" [disabled]="disableCreateAction()"><i
                                            class="fa fa-plus"></i> {{ 'add' | translate }}
                                    </button>
                                </div>
                            </div>
                            <jhi-workbench-location-list [locationTypes]="[LocationTypeEnum.BLOCK]"
                                                         (onSelect)="onBlockItemSelect($event);"
                                                         (onEditItem)="onBlockItemEdit($event)"
                                                         (onDeleteItem)="onBlockItemDelete($event)"
                                                         [parentLocationId]="selectedField"
                                                         #blockList></jhi-workbench-location-list>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container-fluid scroll-container-bottom divider bottom-section-white">
                <jhi-plot-details-view [shape]="plotHover || selectedFieldFieldMapShape"></jhi-plot-details-view>
            </div>

        </mat-sidenav>
        <mat-sidenav-content>
            <button class="btn btn-outline-secondary sidebar-toggle left-toggle" (click)="toggleLeftSidenav()"><i
                    class="fa" [class.fa-chevron-left]="leftSidenavOpen"
                    [class.fa-chevron-right]="!leftSidenavOpen"> </i></button>
            <button class="btn btn-outline-secondary sidebar-toggle right-toggle" (click)="toggleRightSidenav()"><i
                    class="fa" [class.fa-chevron-right]="rightSidenavOpen"
                    [class.fa-chevron-left]="!rightSidenavOpen"> </i></button>
            <div class="main-content">
                <div class="container-fluid px-5">
                    <div class="row mt-2">
                        <div class="col">
                            <h2>
                                <span jhiTranslate="field-manager.title">Fieldmap Manager</span>&nbsp;
                                <jhi-help-link [helpLink]="helpLink"></jhi-help-link>
                            </h2>
                        </div>
                    </div>
                    <div class="row mb-10 justify-content-center">
                        <div class="col-12">
                            <div class="btn-toolbar">
                                <div class="btn-group me-2 mb-2" *ngIf="isSelected()">
                                    <label class="btn btn-outline-secondary"
                                           [class.field]="selectedFieldFieldMapShape.type === 'FIELD'"
                                           [class.block]="selectedFieldFieldMapShape.type === 'BLOCK'"
                                           [class.study]="selectedFieldFieldMapShape.type === 'STUDY'"
                                           *ngIf="isSelected()">
                                        <span class="badge text-bg-light">{{ ('field-manager.entity.' + selectedFieldFieldMapShape.type) | translate }}</span>
                                    </label>
                                    <label class="btn btn-outline-secondary"
                                           [class.active]="fieldMapContext.editOptionsSelectedValue === 'EDIT'"
                                           *ngIf="selectedFieldFieldMapShape && selectedFieldFieldMapShape.isEditable()">
                                        <input type="radio" class="btn-check" autocomplete="off"
                                               [(ngModel)]="fieldMapContext.editOptionsSelectedValue"
                                               (ngModelChange)="editToolAction()"
                                               [value]="'EDIT'" #edit> <i
                                            class="fa fa-edit"></i> {{ 'entity.action.edit' | translate }}
                                    </label>
                                    <label class="btn btn-outline-secondary"
                                           [class.active]="fieldMapContext.editOptionsSelectedValue === 'RESIZE'"
                                           *ngIf="selectedFieldFieldMapShape && selectedFieldFieldMapShape.isResizable()">
                                        <input type="radio" class="btn-check" autocomplete="off"
                                               [(ngModel)]="fieldMapContext.editOptionsSelectedValue"
                                               (ngModelChange)="editToolAction()"
                                               [value]="'RESIZE'" #resize> <i
                                            class="fa fa-expand"></i> {{ 'field-manager.action.resize' | translate }}
                                    </label>
                                    <label class="btn btn-outline-secondary"
                                           [class.active]="fieldMapContext.editOptionsSelectedValue === 'ROTATE'"
                                           *ngIf="selectedFieldFieldMapShape && selectedFieldFieldMapShape.isRotatable()">
                                        <input type="radio" class="btn-check" autocomplete="off"
                                               [(ngModel)]="fieldMapContext.editOptionsSelectedValue"
                                               (ngModelChange)="editToolAction()"
                                               [value]="'ROTATE'" #rotate> <i
                                            class="fa fa-repeat"></i> {{ 'field-manager.action.rotate' | translate }}
                                    </label>
                                </div>
                                <div class="btn-group me-2 mb-2" role="group" aria-label="Basic example"
                                     *ngIf="showSave()">
                                    <button type="button" class="btn btn-primary" (click)="saveToolAction()"
                                            [disabled]="!isSaveEnabled()"><i class="fa fa-save"></i> {{ 'save' | translate }}
                                    </button>
                                    <button type="button" class="btn btn-outline-dark"
                                            (click)="cancelToolAction()" [disabled]="!isSaveEnabled()">{{ 'cancel' | translate }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row mt-2 mb-10 justify-content-center">
                        <div class="col-10">
                            <div *ngIf="isLoading" class="alert alert-light border shadow-sm p-2 text-center my-1">
                                <span class="throbber"></span>
                                <span class="ps-2 text-muted">{{ loadingMessage }}</span>
                            </div>
                            <div *ngIf="snackBarType === 'INFO' && snackBarMessage"
                                 class="alert alert-info text-center d-flex align-items-center justify-content-center">
                                <i class="fa fa-info-circle fa-1x me-2"></i>
                                <span>{{ snackBarMessage }}</span>
                            </div>
                            <div *ngIf="snackBarType === 'WARNING' && snackBarMessage"
                                 class="alert alert-warning text-center d-flex align-items-center justify-content-center">
                                <i class="fa fa-info-circle fa-1x me-2"></i>
                                <span>{{ snackBarMessage }}</span>
                            </div>
                            <div *ngIf="snackBarType === 'ERROR' && snackBarMessage"
                                 class="alert alert-danger text-center d-flex align-items-center justify-content-center">
                                <i class="fa fa-exclamation-circle fa-1x me-2"></i>
                                <span>{{ snackBarMessage }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="map" class="map"></div>
                <div class="location-search-div">
                    <jhi-location-search (locationSelected)="onLocationSelected($event)"></jhi-location-search>
                </div>
            </div>
        </mat-sidenav-content>
        <!-- Toggle button for right sidebar -->

        <mat-sidenav #sideNavRight mode="side" [opened]="rightSidenavOpen"
                     [fixedInViewport]="true" position="end" class="right-sidenav">
            <jhi-study-instances-view (onAssign)="startCreateStudy($event)"
                                      (onUnAssign)="unAssignStudy($event)"
                                      (onLoadStudy)="loadStudy($event)"
                                      (onEditStudy)="editStudy($event)"
                                      #studyInstancesView></jhi-study-instances-view>
        </mat-sidenav>
    </mat-sidenav-container>
</div>



